import React from "react";
import { Routes } from "../../constants";

import { Link, useLocation } from "react-router-dom";
import { routes } from "../../constants/routes";

export default function SideBar() {
  const { pathname } = useLocation();
  const splitLocation = pathname.split("/");

  return (
    <React.Fragment>
      <div
        id="removeNotificationModal"
        className="modal fade zoomIn"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="NotificationModalbtn-close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="mt-2 text-center">
                <lord-icon
                  src="https://cdn.lordicon.com/gsqxdxog.json"
                  trigger="loop"
                  colors="primary:#f7b84b,secondary:#f06548"
                  style={{ width: "100px", height: "100px" }}
                ></lord-icon>
                <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                  <h4>Are you sure ?</h4>
                  <p className="text-muted mx-4 mb-0">
                    Are you sure you want to remove this Notification ?
                  </p>
                </div>
              </div>
              <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button
                  type="button"
                  className="btn w-sm btn-light"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn w-sm btn-danger"
                  id="delete-notification"
                >
                  Yes, Delete It!
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box">
          <a href="/admin" className="logo logo-light">
            <span className="logo-sm">
              <img src="/assets/images/logo-sm.png" alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src="/assets/images/logo-swallow.jpg" alt="" height="45" />
            </span>
          </a>
          <button
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>

        <div className="dropdown sidebar-user m-1 rounded">
          <button
            type="button"
            className="btn material-shadow-none"
            id="page-header-user-dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span className="d-flex align-items-center gap-2">
              <img
                className="rounded header-profile-user"
                src="/assets/images/users/avatar-1.jpg"
                alt="Header Avatar"
              />
              <span className="text-start">
                <span className="d-block fw-medium sidebar-user-name-text">
                  Anna Adame
                </span>
                <span className="d-block fs-14 sidebar-user-name-sub-text">
                  <i className="ri ri-circle-fill fs-10 text-success align-baseline"></i>{" "}
                  <span className="align-middle">Online</span>
                </span>
              </span>
            </span>
          </button>
          <div className="dropdown-menu dropdown-menu-end">
            <h6 className="dropdown-header">Welcome Anna!</h6>
            <Link className="dropdown-item" to={routes.ADMIN_PROFILE}>
              <i className="fa-regular fa-circle-user"></i>{" "}
              <span className="align-middle">Profile</span>
            </Link>
            <a className="dropdown-item" href="apps-chat.html">
              <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">Messages</span>
            </a>
            <a className="dropdown-item" href="apps-tasks-kanban.html">
              <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">Taskboard</span>
            </a>
            <a className="dropdown-item" href="pages-faqs.html">
              <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">Help</span>
            </a>
            <div className="dropdown-divider"></div>
            <a className="dropdown-item" href="pages-profile.html">
              <i className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">
                Balance : <b>$5971.67</b>
              </span>
            </a>
            <a className="dropdown-item" href="pages-profile-settings.html">
              <span className="badge bg-success-subtle text-success mt-1 float-end">
                New
              </span>
              <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">Settings</span>
            </a>
            <a className="dropdown-item" href="auth-lockscreen-basic.html">
              <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">Lock screen</span>
            </a>
            <a className="dropdown-item" href="auth-logout-basic.html">
              <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle" data-key="t-logout">
                Logout
              </span>
            </a>
          </div>
        </div>
        <div id="scrollbar">
          <div className="container-fluid">
            <div id="two-column-menu"></div>
            <ul className="navbar-nav" id="navbar-nav">
              {/* <li className="menu-title">
                <span data-key="t-menu">Admin</span>
              </li> */}
              <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_DASHBOARD}
                  aria-expanded="false"
                  aria-controls="sidebarDashboards"
                >
                  <i className="ri-dashboard-line"></i>{" "}
                  <span data-key="t-dashboards">Dashboards</span>
                </Link>
              </li>

              <li className="nav-item">
                <a
                  className="nav-link menu-link"
                  href="#sidebarMasters"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarMasters"
                >
                  <i className="ri-apps-2-line"></i>{" "}
                  <span data-key="t-apps">Masters</span>
                </a>
                <div className="collapse menu-dropdown" id="sidebarMasters">
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      <Link
                        to={Routes.ADMIN_DOCUMENT_TYPE}
                        className="nav-link"
                        data-key="t-basic"
                      >
                        Document Type
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to={Routes.ADMIN_EVENT_CATEGORY}
                        className="nav-link"
                        data-key="t-basic"
                      >
                        Event Category
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>

              {/* <li className="nav-item">
                <a
                  className="nav-link menu-link"
                  href="#sidebarEvents"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarEvents"
                >
                  <i className="ri-calendar-event-line"></i>
                  <span data-key="t-authentication"> Events</span>
                </a>
              </li> */}
              <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_MANAGE_EVENTS}
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarEventOrg"
                >
                  <i className="ri-coupon-3-line"></i>{" "}
                  <span data-key="t-dashboards">Event Management</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_MANAGE_USERS}
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarEventTraders"
                >
                  <i class="fa-solid fa-users"></i>{" "}
                  <span data-key="t-dashboards">Manage New Users</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_EVENT_ORGANIZER_LIST}
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarEventOrg"
                >
                  <i className="ri-coupon-3-line"></i>{" "}
                  <span data-key="t-dashboards">Event Organisers</span>
                </Link>
                {/* <a
                  className="nav-link menu-link"
                  href={routes.EVENT_ORGANIZER_LIST}
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarEventOrg"
                >
                  <i className="ri-coupon-3-line"></i>{" "}
                  <span data-key="t-dashboards">Event Organizer</span>
                </a> */}
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_TRADERS_LIST}
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarEventTraders"
                >
                  <i className="ri-price-tag-3-line"></i>{" "}
                  <span data-key="t-dashboards">Event Traders</span>
                </Link>
              </li>

              {/* <li className="nav-item">
                <a
                  className="nav-link menu-link"
                  href="!#"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarPitchManagement"
                >
                  <i className="ri-dashboard-2-line"></i>{" "}
                  <span data-key="t-dashboards">Pitch Management</span>
                </a>
              </li> */}

              <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_SUBSCRIPTION}
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarSubscriptionManagement"
                >
                  <i className="ri-bank-card-2-fill"></i>{" "}
                  <span data-key="t-dashboards">Subscription Management</span>
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_SUB_ENQ}
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarSubscriptionManagement"
                >
                  <i className="fa-solid fa-list-ul"></i>{" "}
                  <span data-key="t-dashboards">
                    Subscription Enquiry Management
                  </span>
                </Link>
              </li>

              {/* Manage Contract */}
              <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_CONTRACT}
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarSubscriptionManagement"
                >
                  <i className="ri-dashboard-2-line"></i>{" "}
                  <span data-key="t-dashboards">Contract Management</span>
                </Link>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link menu-link"
                  href="#sidebarTransactions"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarTransactions"
                >
                  <i class="ri-money-pound-circle-line"></i>{" "}
                  <span data-key="t-apps">Manage Transactions</span>
                </a>
                <div
                  className="collapse menu-dropdown"
                  id="sidebarTransactions"
                >
                  <ul className="nav nav-sm flex-column">
                    <li className="nav-item">
                      <Link
                        className="nav-link menu-link"
                        to={Routes.ADMIN_TRANSACTIONS_LIST}
                        role="button"
                        aria-expanded="false"
                        aria-controls="sidebarPayments"
                      >
                        <i className="ri-numbers-line"></i>{" "}
                        <span data-key="t-dashboards">
                          Payments & Transactions
                        </span>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link menu-link"
                        to={Routes.ADMIN_PITCH_TRANSACTION_REPORT}
                        role="button"
                        aria-expanded="false"
                        aria-controls="sidebarFeedback"
                      >
                        <i class="ri-bar-chart-line"></i>{" "}
                        <span data-key="t-dashboards">Sales Summary</span>
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link
                        className="nav-link menu-link"
                        to={Routes.ADMIN_TICKET_TRANSACTION_REPORT}
                        role="button"
                        aria-expanded="false"
                        aria-controls="sidebarFeedback"
                      >
                        <i className="ri-ticket-line"></i>{" "}
                        <span data-key="t-dashboards">Ticket Management</span>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link menu-link"
                        to={Routes.ADMIN_INVOICE}
                        role="button"
                        aria-expanded="false"
                        aria-controls="sidebarFeedback"
                      >
                        <i class="ri-money-pound-circle-line"></i>{" "}
                        {/* <i className="ri-ticket-line"></i> */}
                        <span data-key="t-dashboards">Invoice Management</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>
              {/* Static Page */}
              <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_STATICPAGE}
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarFeedback"
                >
                  <i className="fa-solid fa-file-lines"></i>{" "}
                  <span data-key="t-dashboards">Static Page Content</span>
                </Link>
              </li>

              {/* FAQ PAGE */}
              <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_FAQ_LIST}
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarFeedback"
                >
                  <i className="fa-solid fa-question"></i>{" "}
                  <span data-key="t-dashboards">FAQ</span>
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_FEEDBACKS_LIST}
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarFeedback"
                >
                  <i className="ri-discuss-line"></i>{" "}
                  <span data-key="t-dashboards">Feedback & Complaints</span>
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_INQUIRY}
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarFeedback"
                >
                  <i className="fas fa-info-circle"></i>{" "}
                  <span data-key="t-dashboards">Contact-us(Enquiry)</span>
                </Link>
              </li>

              {/* <li className="nav-item">
                <a
                  className="nav-link menu-link"
                  href="!#"
                  data-bs-toggle="collapse"
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarContentManagement"
                >
                  <i className="ri-pages-line"></i>{" "}
                  <span data-key="t-dashboards">Content Management</span>
                </a>
              </li> */}

              <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_GLOBALSETTINGS}
                  role="button"
                  aria-expanded="false"
                  aria-controls="sidebarGlobalSettings"
                >
                  <i className="fa fa-cog"></i>{" "}
                  <span data-key="t-dashboards">Global Settings</span>
                </Link>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link menu-link"
                  href="https://analytics.google.com/analytics"
                  role="button"
                  target="_blank"
                  aria-expanded="false"
                  aria-controls="sidebarGlobalSettings"
                  rel="noreferrer"
                >
                  <i className="fa fa-database"></i>{" "}
                  <span data-key="t-dashboards">Report</span>
                </a>
              </li>
              {/* <li className="nav-item">
                <Link
                  className="nav-link menu-link"
                  to={Routes.ADMIN_ENQUIRY}                 
                  aria-expanded="false"
                  aria-controls="sidebarEnquiryManagement"
                >
                  <i className="ri-chat-poll-line"></i>{" "}
                  <span data-key="t-dashboards">Enquiry management</span>
                </Link>
              </li> */}
            </ul>
          </div>
        </div>

        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
}
